
import { useContext } from '@nuxtjs/composition-api';
import useCheckout from '@/composable/checkout/useCheckout';

export default {
  setup() {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const { customerInfo } = state;
    const { permissionsAccepted } = customerInfo
    const onChangeNewsPerm = e => {
      permissionsAccepted.value = e
    }
    return {
      onChangeNewsPerm,
      permissionsAccepted,
      customerInfo
    }
  }
}
